// src/components/AuthGuard.js
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const hasAuth = localStorage.getItem('isAuthenticated');
    localStorage.setItem('lastVisitedPath', location.pathname);

    if (!hasAuth) {
      navigate('/');
    } else {
      setIsAuthenticated(true);
    }
  }, [navigate, location]);

  return isAuthenticated ? children : null;
};

export default AuthGuard;
